import apiConfig from '../redux/authentication/utils/core/apiConfig';

// Backend-hosted media (currently just /api/v1/uploads/... -- real uploaded
// display pictures, served by Main.py's StaticFiles mount) has to resolve
// against the API's actual origin, not the current page's. In production
// frontend and backend share an origin behind nginx so a bare relative path
// just works, but local dev sets REACT_APP_BACKEND_URL to a genuinely
// different origin (frontend :3000, backend :8000) -- a raw
// <img src="/api/v1/..."> then silently resolves against :3000 and hits the
// CRA dev server's own SPA fallback (200, text/html, empty body) instead of
// the real file. Frontend-native paths (/avatars/...) are bundled into this
// app's own public/ folder and must stay resolved against the current
// origin, so they're returned untouched.
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string' || !url.startsWith('/api/')) return url;
  const apiOrigin = apiConfig.API.baseUrl.replace(/\/api\/v1\/?$/, '');
  return `${apiOrigin}${url}`;
}
